import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modalSection: {
    padding: "0 1rem",
  },

  paperBody: {
    marginTop: 12,
    width: "100%",
  },
  button: {
    cursor: "pointer",
  },
}));

export default styles;
